export const PRODUCT_STATUS = {
  ACTIVE: "active",
  COMING_SOON: "coming-soon",
  HIDDEN: "hidden",
};

export const products = [
  {
    id: "fikami-emprende-facil",
    slug: "emprende-facil",
    name: {
      es: "FIKAMI Emprende Fácil",
      en: "FIKAMI Easy Start",
    },
    subtitle: {
      es: "Presencia y organización para pequeños negocios",
      en: "Business presence and organization for small teams",
    },
    shortDescription: {
      es: "Organiza clientes, citas, ventas, mensajes de WhatsApp y contenido de tu pequeño negocio con plantillas editables en español.",
      en: "Organize clients, appointments, sales, WhatsApp messages, and content for your small business with editable Spanish templates.",
    },
    longDescription: {
      es: "Un paquete práctico para trabajadores independientes y pequeños negocios que necesitan ordenar su operación, presentar mejor sus servicios y atender clientes desde el celular sin contratar software complejo.",
      en: "A practical package for independent professionals and small businesses that need to organize operations, present services clearly, and serve clients from a phone without complex software.",
    },
    price: 5,
    currency: "USD",
    images: {
      card: "/products/emprende-facil.svg",
      hero: "/products/emprende-facil.svg",
      alt: {
        es: "Vista del paquete digital FIKAMI Emprende Fácil",
        en: "Preview of the FIKAMI Easy Start digital package",
      },
    },
    features: {
      es: [
        "Cuaderno editable del negocio",
        "Tarjeta digital",
        "Mensajes para WhatsApp",
        "Agenda de clientes, citas y ventas",
        "30 ideas de contenido",
        "Guía visual",
        "Archivos Word, Excel y PDF",
      ],
      en: [
        "Editable business workbook",
        "Digital business card",
        "WhatsApp message templates",
        "Client, appointment, and sales tracker",
        "30 content ideas",
        "Visual guide",
        "Word, Excel, and PDF files",
      ],
    },
    audience: {
      es: [
        "Emprendedores",
        "Trabajadores independientes",
        "Profesionales que venden servicios",
        "Pequeños negocios que todavía se organizan por mensajes o libretas",
      ],
      en: [
        "Entrepreneurs",
        "Independent professionals",
        "Service providers",
        "Small businesses still organizing work through messages or notebooks",
      ],
    },
    purchaseUrl: "https://fikami.gumroad.com/l/emprende-facil",
    purchaseLinks: {
      gumroad: "https://fikami.gumroad.com/l/emprende-facil",
      lemonSqueezy: "",
    },
    status: PRODUCT_STATUS.ACTIVE,
    featured: true,
    language: ["es"],
    category: "templates",
    externalCosts: {
      es: [
        "No requiere suscripciones obligatorias para editar los archivos incluidos.",
        "Las aplicaciones o servicios externos que decidas usar se pagan por separado.",
      ],
      en: [
        "No mandatory subscription is required to edit the included files.",
        "Any optional third-party application or service is paid separately.",
      ],
    },
    installationAvailable: true,
    installationUrl: "https://fikamillc.com/",
    howItWorks: {
      es: [
        "Compra el paquete en Gumroad.",
        "Descarga los archivos y abre la guía visual.",
        "Personaliza los documentos con la información de tu negocio.",
        "Usa las plantillas para organizar y atender mejor a tus clientes.",
      ],
      en: [
        "Purchase the package through Gumroad.",
        "Download the files and open the visual guide.",
        "Customize the documents with your business information.",
        "Use the templates to organize work and serve clients more effectively.",
      ],
    },
    requirements: {
      es: [
        "Teléfono, tableta o computadora",
        "Una aplicación compatible con Word, Excel o PDF",
        "Conexión a internet para descargar el paquete",
      ],
      en: [
        "Phone, tablet, or computer",
        "An application compatible with Word, Excel, or PDF",
        "Internet connection to download the package",
      ],
    },
    notIncluded: {
      es: [
        "Configuración personalizada por FIKAMI",
        "Dominio, hosting o campañas publicitarias",
        "Automatizaciones o integraciones a medida",
      ],
      en: [
        "Personal setup by FIKAMI",
        "Domain, hosting, or advertising campaigns",
        "Custom automations or integrations",
      ],
    },
  },
  {
    id: "fikami-business-starter-pack",
    slug: "business-starter-pack",
    name: {
      es: "FIKAMI Business Starter Pack",
      en: "FIKAMI Business Starter Pack",
    },
    subtitle: {
      es: "Captación, gestión y preparación para automatizar",
      en: "Lead capture, management, and automation readiness",
    },
    shortDescription: {
      es: "Landing editable, dashboard comercial y recursos para captar, organizar y preparar la automatización de clientes.",
      en: "An editable landing page, commercial dashboard, and resources to capture, organize, and prepare customer automation.",
    },
    longDescription: {
      es: "Un sistema inicial para negocios que ya necesitan algo más que plantillas: una landing editable, un dashboard comercial y materiales para estructurar conversaciones, leads, citas, ventas y una futura automatización.",
      en: "A starter system for businesses that need more than templates: an editable landing page, a commercial dashboard, and materials to structure conversations, leads, appointments, sales, and future automation.",
    },
    price: 39,
    currency: "USD",
    images: {
      card: "/products/business-starter-pack.svg",
      hero: "/products/business-starter-pack.svg",
      alt: {
        es: "Vista del FIKAMI Business Starter Pack",
        en: "Preview of the FIKAMI Business Starter Pack",
      },
    },
    features: {
      es: [
        "Landing HTML, CSS y JavaScript",
        "Dashboard de leads, clientes, citas y ventas",
        "Prompts y FAQs para Convocore",
        "Flujos de conversación",
        "Mensajes comerciales",
        "Guías visuales",
        "Checklists de configuración y pruebas",
        "Tarifa especial de instalación con FIKAMI",
      ],
      en: [
        "HTML, CSS, and JavaScript landing page",
        "Lead, client, appointment, and sales dashboard",
        "Prompts and FAQs for Convocore",
        "Conversation flows",
        "Commercial messages",
        "Visual guides",
        "Setup and testing checklists",
        "Special FIKAMI installation rate",
      ],
    },
    audience: {
      es: [
        "Pequeños negocios que quieren captar leads desde una landing",
        "Profesionales y equipos que necesitan ordenar clientes y ventas",
        "Negocios que planean incorporar un asistente virtual",
        "Personas con conocimientos básicos para editar archivos web",
      ],
      en: [
        "Small businesses that want to capture leads from a landing page",
        "Professionals and teams that need to organize clients and sales",
        "Businesses preparing to add a virtual assistant",
        "People with basic knowledge to edit web files",
      ],
    },
    purchaseUrl: "https://fikami.gumroad.com/l/business-starter-pack",
    purchaseLinks: {
      gumroad: "https://fikami.gumroad.com/l/business-starter-pack",
      lemonSqueezy: "",
    },
    status: PRODUCT_STATUS.ACTIVE,
    featured: true,
    language: ["es"],
    category: "automation",
    externalCosts: {
      es: [
        "Dominio y hosting, si decides publicar la landing.",
        "Planes de Convocore u otras plataformas externas, si decides utilizarlas.",
        "Servicios de correo, CRM o automatización contratados por separado.",
      ],
      en: [
        "Domain and hosting if you publish the landing page.",
        "Convocore or other third-party platform plans if you use them.",
        "Email, CRM, or automation services contracted separately.",
      ],
    },
    installationAvailable: true,
    installationUrl: "https://fikamillc.com/",
    howItWorks: {
      es: [
        "Compra y descarga el paquete desde Gumroad.",
        "Revisa las guías y define la información comercial de tu negocio.",
        "Edita la landing y configura el dashboard.",
        "Prepara los prompts, FAQs y flujos para tu asistente virtual.",
        "Publica por tu cuenta o solicita la instalación especial con FIKAMI.",
      ],
      en: [
        "Purchase and download the package from Gumroad.",
        "Review the guides and define your business information.",
        "Edit the landing page and configure the dashboard.",
        "Prepare prompts, FAQs, and flows for your virtual assistant.",
        "Publish it yourself or request the special FIKAMI installation service.",
      ],
    },
    requirements: {
      es: [
        "Computadora para editar los archivos web",
        "Editor de código como VS Code",
        "Navegador moderno",
        "Hosting y dominio para publicar la landing",
      ],
      en: [
        "Computer to edit the web files",
        "Code editor such as VS Code",
        "Modern web browser",
        "Hosting and domain to publish the landing page",
      ],
    },
    notIncluded: {
      es: [
        "Dominio, hosting o cuentas de plataformas externas",
        "Configuración personalizada, salvo que se contrate la instalación",
        "Integraciones avanzadas o desarrollo de funciones nuevas",
        "Campañas de publicidad o gestión comercial continua",
      ],
      en: [
        "Domain, hosting, or third-party platform accounts",
        "Personal setup unless the installation service is purchased",
        "Advanced integrations or development of new features",
        "Advertising campaigns or ongoing sales management",
      ],
    },
  },
  {
    id: "fikami-deliver",
    slug: "fikami-deliver",
    name: {
      es: "FIKAMI Deliver",
      en: "FIKAMI Deliver",
    },
    subtitle: {
      es: "Portal de proyectos para agencias, estudios y profesionales",
      en: "Client project portal for agencies, studios, and professionals",
    },
    shortDescription: {
      es: "Centraliza clientes, proyectos, entregas, archivos, versiones y aprobaciones en un portal profesional.",
      en: "Centralize clients, projects, deliveries, files, versions, and approvals in a professional portal.",
    },
    longDescription: {
      es: "FIKAMI Deliver es una aplicación web para gestionar proyectos y ofrecer a cada cliente un portal privado. Permite compartir avances, organizar entregas, solicitar aprobaciones y mantener los archivos finales en un solo lugar, sin depender de cadenas de WhatsApp o correos dispersos.",
      en: "FIKAMI Deliver is a web application for managing projects and giving each client a private portal. It lets you share progress, organize deliveries, request approvals, and keep final files in one place without relying on scattered WhatsApp threads or emails.",
    },
    price: 49,
    currency: "USD",
    priceLabel: {
      es: "Precio de lanzamiento",
      en: "Launch price",
    },
    images: {
      card: "/products/fikami-deliver.png",
      hero: "/products/fikami-deliver.png",
      alt: {
        es: "Panel administrativo y portal de clientes de FIKAMI Deliver",
        en: "FIKAMI Deliver admin dashboard and client portal",
      },
    },
    features: {
      es: [
        "Panel administrativo para clientes y proyectos",
        "Portal privado para cada cliente",
        "Entregas, versiones y aprobaciones",
        "Carga y organización de archivos",
        "Seguimiento de avances y estados",
        "Descarga de archivos finales",
        "Base preparada con React, Vite y Supabase",
        "Guía para configuración y publicación",
      ],
      en: [
        "Admin dashboard for clients and projects",
        "Private portal for every client",
        "Deliveries, versions, and approvals",
        "File upload and organization",
        "Progress and status tracking",
        "Final file downloads",
        "React, Vite, and Supabase foundation",
        "Setup and publishing guide",
      ],
    },
    audience: {
      es: [
        "Agencias creativas y de marketing",
        "Estudios de diseño, fotografía o producción",
        "Desarrolladores y profesionales independientes",
        "Equipos que entregan proyectos y necesitan aprobaciones claras",
      ],
      en: [
        "Creative and marketing agencies",
        "Design, photography, or production studios",
        "Developers and independent professionals",
        "Teams that deliver projects and need clear approvals",
      ],
    },
    purchaseUrl: "https://fikami.gumroad.com/l/fikami-deliver",
    purchaseLinks: {
      gumroad: "https://fikami.gumroad.com/l/fikami-deliver",
      lemonSqueezy: "",
    },
    demoUrl: "https://fikami-deliver.vercel.app",
    status: PRODUCT_STATUS.ACTIVE,
    featured: true,
    language: ["es"],
    category: "software",
    externalCosts: {
      es: [
        "El comprador conecta y administra su propia cuenta de Supabase.",
        "El comprador utiliza su propia cuenta de GitHub para guardar el proyecto.",
        "El comprador conecta su propia cuenta de Vercel para publicar la aplicación.",
        "Los planes de pago, dominio propio u otros servicios externos se contratan por separado.",
      ],
      en: [
        "The buyer connects and manages their own Supabase account.",
        "The buyer uses their own GitHub account to store the project.",
        "The buyer connects their own Vercel account to publish the application.",
        "Paid plans, a custom domain, and other external services are purchased separately.",
      ],
    },
    installationAvailable: true,
    installationUrl: "https://fikamillc.com/",
    howItWorks: {
      es: [
        "Compra y descarga FIKAMI Deliver desde Gumroad.",
        "Crea o conecta tus cuentas de Supabase, GitHub y Vercel.",
        "Configura las variables y personaliza la información de tu negocio.",
        "Publica el portal y comienza a crear clientes y proyectos.",
        "Configúralo por tu cuenta o contrata la instalación profesional de FIKAMI.",
      ],
      en: [
        "Purchase and download FIKAMI Deliver from Gumroad.",
        "Create or connect your Supabase, GitHub, and Vercel accounts.",
        "Configure the variables and customize your business information.",
        "Publish the portal and start creating clients and projects.",
        "Set it up yourself or hire FIKAMI for professional installation.",
      ],
    },
    requirements: {
      es: [
        "Computadora y conexión a internet",
        "Cuenta propia de Supabase",
        "Cuenta propia de GitHub",
        "Cuenta propia de Vercel",
        "Conocimientos básicos de VS Code y configuración web, o contratar la instalación",
      ],
      en: [
        "Computer and internet connection",
        "Your own Supabase account",
        "Your own GitHub account",
        "Your own Vercel account",
        "Basic VS Code and web setup knowledge, or purchase installation",
      ],
    },
    notIncluded: {
      es: [
        "Cuentas, suscripciones o consumos de Supabase, GitHub o Vercel",
        "Dominio personalizado",
        "Instalación y configuración profesional por FIKAMI",
        "Personalizaciones, nuevas funciones o integraciones especiales",
      ],
      en: [
        "Supabase, GitHub, or Vercel accounts, subscriptions, or usage",
        "Custom domain",
        "Professional installation and configuration by FIKAMI",
        "Customizations, new features, or special integrations",
      ],
    },
  },
];

export const futureProductIdeas = [
  "MedicBro White Label",
  "Travik",
  "Kits especializados",
  "Software marca blanca",
];

export const productUi = {
  es: {
    nav: "Productos",
    eyebrow: "PRODUCTOS DIGITALES",
    homeTitle: "Recursos listos para organizar y hacer crecer tu negocio.",
    homeSubtitle: "Compra, descarga y configura por tu cuenta; o solicita a FIKAMI una instalación personalizada.",
    catalogTitle: "Productos digitales FIKAMI",
    catalogSubtitle: "Plantillas, sistemas iniciales y recursos prácticos para presentar, organizar y automatizar un negocio.",
    viewCatalog: "Ver todos los productos",
    viewDetails: "Ver detalles",
    viewDemo: "Ver demo",
    buyNow: "Comprar ahora",
    comingSoon: "Próximamente",
    from: "Precio",
    included: "Contenido incluido",
    forWhom: "¿Para quién es?",
    howItWorks: "Cómo funciona",
    requirements: "Requisitos",
    externalCosts: "Costos externos",
    notIncluded: "Qué no incluye",
    filters: {
      all: "Todos",
      templates: "Plantillas",
      automation: "Automatización",
      software: "Software",
      "coming-soon": "Próximamente",
    },
    empty: "Todavía no hay productos en esta categoría.",
    languageLabel: "Idioma",
    backCatalog: "Volver al catálogo",
    purchaseOn: "Comprar en Gumroad",
    installationTitle: "¿Prefieres que FIKAMI lo configure por ti?",
    installationText: "Los compradores pueden solicitar personalización, instalación y configuración con una tarifa especial.",
    installationCta: "Solicitar instalación",
    convocoreTitle: "Activa tu asistente virtual",
    convocoreText: "Crea tu cuenta de Convocore y configura un asistente para responder preguntas, captar datos y apoyar la atención de tu negocio.",
    convocoreCta: "Crear cuenta en Convocore",
    notFoundTitle: "Producto no encontrado",
    notFoundText: "El producto no existe, está oculto o todavía no se encuentra disponible.",
  },
  en: {
    nav: "Products",
    eyebrow: "DIGITAL PRODUCTS",
    homeTitle: "Ready-to-use resources to organize and grow your business.",
    homeSubtitle: "Purchase, download, and configure them yourself, or request a personalized FIKAMI installation.",
    catalogTitle: "FIKAMI digital products",
    catalogSubtitle: "Templates, starter systems, and practical resources to present, organize, and automate a business.",
    viewCatalog: "View all products",
    viewDetails: "View details",
    viewDemo: "View demo",
    buyNow: "Buy now",
    comingSoon: "Coming soon",
    from: "Price",
    included: "What's included",
    forWhom: "Who it is for",
    howItWorks: "How it works",
    requirements: "Requirements",
    externalCosts: "External costs",
    notIncluded: "What's not included",
    filters: {
      all: "All",
      templates: "Templates",
      automation: "Automation",
      software: "Software",
      "coming-soon": "Coming soon",
    },
    empty: "There are no products in this category yet.",
    languageLabel: "Language",
    backCatalog: "Back to catalog",
    purchaseOn: "Buy on Gumroad",
    installationTitle: "Would you rather have FIKAMI configure it for you?",
    installationText: "Buyers can request personalization, installation, and configuration at a special rate.",
    installationCta: "Request installation",
    convocoreTitle: "Activate your virtual assistant",
    convocoreText: "Create your Convocore account and configure an assistant to answer questions, capture data, and support your business customer service.",
    convocoreCta: "Create a Convocore account",
    notFoundTitle: "Product not found",
    notFoundText: "This product does not exist, is hidden, or is not available yet.",
  },
};

export const localize = (value, lang = "es") => {
  if (value == null) return value;
  if (Array.isArray(value)) return value;
  if (typeof value !== "object") return value;
  return value[lang] ?? value.es ?? value.en ?? "";
};

export const getProductUi = (lang) => productUi[lang] || productUi.es;

export const getVisibleProducts = () =>
  products.filter((product) => product.status !== PRODUCT_STATUS.HIDDEN);

export const getFeaturedProducts = () =>
  products.filter(
    (product) => product.featured && product.status === PRODUCT_STATUS.ACTIVE,
  );

export const getProductBySlug = (slug) =>
  products.find(
    (product) =>
      product.slug === slug && product.status !== PRODUCT_STATUS.HIDDEN,
  );

export const getPrimaryPurchaseLink = (product) =>
  product?.purchaseLinks?.gumroad ||
  product?.purchaseLinks?.lemonSqueezy ||
  product?.purchaseUrl ||
  "";

export const formatProductPrice = (product) => {
  if (product?.status === PRODUCT_STATUS.COMING_SOON || product?.price == null) {
    return "";
  }
  return `${product.currency} $${new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
  }).format(product.price)}`;
};
